<template>
  <div class="">
    <el-table :data="tableData">
      <el-table-column prop="realName" label="账号名称">
        <template slot-scope="scope">
          {{ scope.row.realName || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="手机号">
        <template slot-scope="scope">
          {{ scope.row.userName || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="email" label="邮箱">
        <template slot-scope="scope">
          {{ scope.row.email || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="createTimeString" label="创建日期">
        <template slot-scope="scope">
          {{ scope.row.createTimeString || "--" }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="enable" label="状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enable"
            @change="handleStatuChange(scope.row.id, scope.row.enable)"
          >
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "roleTable",
  props: {
    accountList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },
  watch: {
    accountList(newval) {
      this.tableData = newval;
      this.tableData.forEach((item) => {
        item.enable = item.enable === 1;
      });
    },
    deep: true,
  },
  methods: {
    handleStatuChange(id, status) {
      console.log(id, status);
      const enable = status ? 1 : 0;
      const formData = new FormData();
      formData.append("id", id);
      formData.append("enable", enable);

      this.$post("/user/editAdmin", formData).then((res) => {
        console.log("改变账户状态", res);
      });
    },
  },
};
</script>

<style scoped>
</style>